<div class="container-fluid px-2 px-md-4 border-bottom py-3 border-top border-3 border-danger border-bottom-0">
  @if(!hasUser){
  <div class="row justify-content-center align-items-center">
    <div class="col-auto">
      <figure>
        <img alt="" height="34px" src="../../../assets/img/nav/la-colonial-de-seguros-logo.svg" width="214px">
      </figure>
    </div>
  </div>
  }
  @if(hasUser){
  <div class="row justify-content-between align-items-center">
    <div class="col">
      <div class="d-flex align-items-center gap-2">
        <button (click)="openMobileNav.emit()"
          class="btn px-0 btn-sm d-flex d-md-none btn-outline-light text-colonial rounded-pill">
          <span class="material-symbols-outlined" style="font-size: 2rem;">menu</span>
        </button>
        <div class="h6 mb-0 text-colonial text-center text-md-start d-flex flex-column align-content-center lh-0">
          <span class="fw-semibold fs-5">
            Colonial Vital{{ bankName ? ' - ' + bankName : '' }}
          </span>
        </div>
      </div>
    </div>
    <div class="col d-none d-md-block">
      <div
        class="text-center rounded-3 gap-1 align-content-center px-2 py-1 border gap-0 align-items-center d-flex small justify-content-center bg-light">
        <span class="material-symbols-outlined" style="font-size: 20px;">account_circle</span>
        <span class="fw-normal lh-0 text-center">
          {{user && user.idTokenClaims?.given_name }}
        </span>
      </div>
    </div>
    <div class="col-auto col-md">
      <div class="d-flex gap-2 float-end">
      </div>
    </div>
  </div>
  }
</div>